import React from 'react';
import { Navigate } from 'react-router-dom';
import { useConductorAuth } from '../contexts/ConductorAuthContext';

export const ConductorRoute = ({ children }) => {
  const { conductor, loading } = useConductorAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500">Cargando...</div>
      </div>
    );
  }

  if (!conductor) {
    return <Navigate to="/login" replace />;
  }

  // Si el conductor debe cambiar el password, forzar redirección
  if (conductor.must_change_password && typeof window !== 'undefined' && !window.location.pathname.includes('/cambiar-password')) {
    return <Navigate to="/conductor/cambiar-password" replace />;
  }

  return children;
};
